<template>
  <section style="padding:0 5%;">
    <el-form
      ref="form"
      label-position="top"
      status-icon
      :model="form"
      label-width="100px"
      style="width:100%;"
    >
      <el-form-item label="手机号" prop="phone" >
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname" >
        <el-input v-model="form.nickname" placeholder="请输入昵称"></el-input>
      </el-form-item>
      <el-form-item label="小程序openID" prop="wx_open_id" >
        <el-input v-model="form.wx_open_id" placeholder="请输入小程序openID"></el-input>
      </el-form-item>
      <el-form-item label="支付宝openID" prop="zfb_open_id">
        <el-input v-model="form.zfb_open_id" placeholder="请输入支付宝openID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="close('form')">取消</el-button>
        <el-button type="primary" @click="submit('form')" :plain="true">立即修改</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  let _this;
  import {editData,getDataById} from "@/api/users.js";
  export default {
    props: {
      id: Number
    },
    data() {
      return {
        form: {
          phone: "",
          nickname: "",
          wxOpenID: "",
          alipyOpenID: "",
        },

        
      };
    },

    computed: {},

    mounted() {
      _this = this;
      _this.init();
      this.form.group_id = this.$store.state.user.userData.group_id
    },

    methods: {
      // 初始化数据
      init() {
        getDataById(this.id).then(res=>{
          if(res.code === 200){
            this.form = res.data
            console.log(this.form)
          }
        })
      },
      
      close() {
        _this.$emit("close");
      },
      submit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            editData(this.id,_this.form).then(res => {
              if (res.code === 200) {
                _this.$message({
                  message: "修改成功",
                  type: "success"
                });
                setTimeout(() => {
                  _this.$emit("success");
                }, 1000);
              }
            })
          } else {
            console.log("error submit!!");
            return false;
          }
        })
      }
    }
  };
</script>
<style lang="scss" scoped>
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }
</style>
